module.exports = __webpack_public_path__ + "img/football_logo.9506a35d.svg";